export default "__VITE_ASSET__257752da__"